// extracted by mini-css-extract-plugin
module.exports = {"block":"profileBonusTerm_block__1J6ME","block__title":"profileBonusTerm_block__title__js4B0","date":"profileBonusTerm_date__1Usib","modal":"profileBonusTerm_modal__2-gio"};